import { allCompanyRoles } from "../../../models/CompanyUserRoles.js";
import { widget } from "@foretagsplatsen/widgetjs";
import attachCompanyDialog from "./attachCompanyDialog.js";
import companyCardListWidget from "./companyCardListWidget.js";

/**
 * Displays a list of companies as cards.
 *
 * @param {user} spec.currentUser - User currently logged in
 * @param {user} [spec.editedUser] - User about whom to companies
 * @param {company[]} [spec.attachedCompanies] - Companies attached to `editedUser`
 * @param {function} spec.attachCompanyCallback - Function called when `currentUser` adds a company to `editedUser`
 * @param {function} spec.clientCardFactory - Factory taking a company and returning a cardWidget
 * @param {company[]} [spec.allCompanies] - List of every company the current user can see and which is or could be attached to the edited user. Required only if `currentUser` wants to attach companies to `editedUser`
 */
export default widget.subclass((that, my) => {
	my.initialize = function ({
		currentUser,
		editedUser,
		attachCompanyCallback,
		clientCardFactory,
		allCompanies = [],
		attachedCompanies,
	}) {
		my.super(...arguments);
		my.currentUser = currentUser;
		my.editedUser = editedUser;
		my.attachCompanyCallback = attachCompanyCallback;
		my.clientCardFactory = clientCardFactory;
		my.allCompanies = allCompanies;
		my.attachedCompanies = attachedCompanies;
	};

	my.initializeSubwidgets = function (spec) {
		my.super(spec);

		my.companyCardListWidget = companyCardListWidget({
			canAttachCompany: (company) =>
				my.editedUser &&
				my.currentUser.canAttachCompany(my.editedUser, company),
			clientCardFactory: my.clientCardFactory,
			allCompanies: my.allCompanies,
			getAttachedCompanyIds: () =>
				my.editedUser ? my.editedUser.getCompanyIds() : [],
			showAttachCompany: my.showAttachCompany,
		});
	};

	that.setEditedUser = function (editedUser) {
		my.editedUser = editedUser;
		my.companyCardListWidget.initializeListSource();
		that.update();
	};

	that.renderContentOn = function (html) {
		html.render(my.companyCardListWidget);
	};

	my.showAttachCompany = function (attachableCompanies) {
		const dialog = attachCompanyDialog({
			target: my.editedUser.getName(),
			companies: attachableCompanies,
			displayRoles: my.editedUser.isCompanyUser(),
			roles: allCompanyRoles(),
		});

		dialog.onConfirm.register(my.attachCompanyCallback);
		dialog.show();
	};
});
